import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../../../axios';
import { AUTH_TOKEN } from '../../../../environments';
import { getManagementAppPanelRoute } from '../../utils/apiRoutes';
import { moduleName } from '../../moduleInfo';

export const getManagementAppPanelAsync = createAsyncThunk(
  `${moduleName}/getManagementAppPanelAsync`,
  async (payload) => {
    const { sortby } = payload;
    const response = await axios({
      method: 'GET',
      url: getManagementAppPanelRoute(),
      headers: {
        Authorization: AUTH_TOKEN,
      },
      params: {
        sortby,
      },
    });
    const data = response.data;
    return data;
  }
);

const dashboardManagementReducer = createSlice({
  name: `${moduleName}/dashboard`,
  initialState: {
    loading: false,
    mgmentPanel: null,
    schoolSession: [],
    savedClassNames: [],
    data: {},
    error: '',
  },
  reducers: {
    storeDashboardSchoolId: (state, action) => {
      state.schoolId = action.payload;
    },
  },
  extraReducers: {
    [getManagementAppPanelAsync.pending]: (state) => {
      state.loading = true;
    },
    [getManagementAppPanelAsync.fulfilled]: (state, action) => {
      state.loading = false;
      state.mgmentPanel = action.payload.data;
    },
    [getManagementAppPanelAsync.rejected]: (state) => {
      state.loading = false;
    },
  },
});

export const { storeDashboardSchoolId } = dashboardManagementReducer.actions;

export default dashboardManagementReducer.reducer;
